import { useCrowdfundingProvider } from '#Context/crowdfunding/Crowdfunding.provider';
import { PeerParticipant, useShowCampaignById_new } from '@givebacks/api/store';
import { useFormListValidator } from 'core';
import { createModalsFactory } from 'ui';
import { createFormContext, isNotEmpty, useForm } from 'ui/Form';

type LogActivityFormType = {
  value?: number;
  date?: Date;
  index?: number;
};

const [ActivityLogFormProvider, useActivityLogForm] = createFormContext<LogActivityFormType>();

type LogActivityModalIds = 'base' | 'success';

type LogActivityModalMeta = {
  participant: PeerParticipant;
  unitsOfActivity?: string;
  campaignId: string;
  causeId: string;
  onSuccess?: () => void;
};

const { Provider: LogActivityModalProvider, useProvider: useLogActivityModalProvider } =
  createModalsFactory<LogActivityModalIds[], LogActivityModalMeta>(['base', 'success']);

const LogActivityModalFlow = ({
  participant,
  children,
  onSuccess,
}: {
  participant: PeerParticipant;
  children?: React.ReactNode;
  onSuccess?: () => void;
}) => {
  const { campaignId, causeId } = useCrowdfundingProvider();

  const { data: campaign } = useShowCampaignById_new({
    campaignId,
    causeId,
  });

  const form = useForm<LogActivityFormType>({
    initialValues: {
      value: undefined,
      date: undefined,
      index: undefined,
    },
    validate: {
      value: (value) =>
        value && value < 1
          ? 'Please enter at least 1 unit of activity'
          : isNotEmpty('Please enter at least 1 unit of activity')(value),
      date: isNotEmpty('Please enter a valid date'),
    },
  });

  useFormListValidator({ form, id: `logActivity` });

  if (campaign?.__type !== 'athon') return;
  return (
    <LogActivityModalProvider
      meta={{
        participant,
        unitsOfActivity: campaign.units_of_activity_plural,
        campaignId: campaignId ?? '',
        causeId: causeId ?? '',
        onSuccess,
      }}
    >
      <ActivityLogFormProvider form={form}>{children}</ActivityLogFormProvider>
    </LogActivityModalProvider>
  );
};

export { LogActivityModalFlow, useActivityLogForm, useLogActivityModalProvider };
